import { FormAssetRef } from '@shared/models/form/form-asset.model';

const ATTACHMENT_DESCRIPTION_MAX_LENGTH = 100;
export function isPendingFormAsset(asset: FormAssetRef): boolean {
  if (asset.attachmentId != null) {
    return false;
  }

  return !!(asset.localAssetId || asset.data);
}

export function buildAttachmentDescription(
  formCode: string,
  questionLabel: string,
): string {
  const description = `${formCode} - ${questionLabel}`;
  if (description.length <= ATTACHMENT_DESCRIPTION_MAX_LENGTH) {
    return description;
  }

  return description.slice(0, ATTACHMENT_DESCRIPTION_MAX_LENGTH);
}

export function mapUploadedAttachmentToFormAssetRef(
  metadata: { attachmentId: number; fileName?: string; url?: string },
  fallbackFileName?: string,
): FormAssetRef {
  return {
    attachmentId: metadata.attachmentId,
    fileName: metadata.fileName ?? fallbackFileName,
    url: metadata.url,
  };
}

export function mapAssetsToResponseJsonRefs(assets?: FormAssetRef[]): FormAssetRef[] {
  const mapped: FormAssetRef[] = [];

  for (const asset of assets ?? []) {
    if (!asset.attachmentId && !asset.url && !asset.fileName) {
      continue;
    }

    mapped.push({
      attachmentId: asset.attachmentId,
      fileName: asset.fileName,
      url: asset.url,
    });
  }

  return mapped;
}

export function stripInlineAssetData<T extends { assets?: FormAssetRef[] }>(row: T): T {
  if (!row.assets?.length) {
    return row;
  }

  return {
    ...row,
    assets: row.assets.map((asset) => ({
      attachmentId: asset.attachmentId,
      fileName: asset.fileName,
      url: asset.url,
      localAssetId: asset.localAssetId,
    })),
  };
}
